import './src/main.css';

export const onRouteUpdate = ({ location }) => {
  const isFreezomePage = location.pathname.includes('free-zone');

  const AHREFS_LOADER_ID = 'ahrefs-analytics-loader';
  const AHREFS_SRC = 'https://analytics.ahrefs.com/analytics.js';
  const ahrefsLoader = document.querySelector(`script[data-id="${AHREFS_LOADER_ID}"]`);
  const ahrefsDirect = document.querySelector(`script[src="${AHREFS_SRC}"]`);
  const AHREFS_META_NAME = 'ahrefs-site-verification';
  let ahrefsMeta = document.querySelector(`meta[name="${AHREFS_META_NAME}"]`);
  if (isFreezomePage) {
    if (ahrefsDirect) ahrefsDirect.parentNode.removeChild(ahrefsDirect);
    if (!ahrefsLoader) {
      const loader = document.createElement('script');
      loader.setAttribute('data-id', AHREFS_LOADER_ID);
      loader.textContent = `
  var ahrefs_analytics_script = document.createElement('script');
  ahrefs_analytics_script.async = true;
  ahrefs_analytics_script.src = 'https://analytics.ahrefs.com/analytics.js';
  ahrefs_analytics_script.setAttribute('data-key', '/woqW/5Ej7C6syadaYnwJQ');
  document.getElementsByTagName('head')[0].appendChild(ahrefs_analytics_script);
`;
      document.body.appendChild(loader);
    }
    if (!ahrefsMeta) {
      ahrefsMeta = document.createElement('meta');
      ahrefsMeta.name = AHREFS_META_NAME;
      ahrefsMeta.content = 'eb526eb61623b9fd3cdc0765d7d2fdea726dbe9023647090f61d3f56755f41bc';
      document.head.appendChild(ahrefsMeta);
    }
  } else {
    if (ahrefsLoader) ahrefsLoader.parentNode.removeChild(ahrefsLoader);
    if (ahrefsDirect) ahrefsDirect.parentNode.removeChild(ahrefsDirect);
    if (ahrefsMeta) ahrefsMeta.parentNode.removeChild(ahrefsMeta);
  }

  const isCareersPage = location.pathname.includes('careers');

  if (typeof window !== 'undefined') {
    const head = document.querySelector('head');
    let metaTag = head.querySelector('meta[name="robots"]');

    if (isCareersPage) {
      // If on careers page, ensure noindex meta tag is present
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.name = 'robots';
        metaTag.content = 'noindex';
        head.appendChild(metaTag);
      } else {
        metaTag.content = 'noindex'; // Update if it exists
      }
    } else {
      if (metaTag && metaTag.content === 'noindex') {
        head.removeChild(metaTag);
      }
    }
  }
};
